import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=61eb824c&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=61eb824c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb824c",
  null
  
)

export default component.exports